import { gql } from 'apollo-angular';

const GET_CROSSES_BY_SELLER = gql`
  query getCrosses(
    $searchValue: String!
    $categoryId: Long!
    $sysSellerId: Long!
  ) {
    optimizedPurchasedProducts(
      searchCriteria: {
        limit: 50
        searchValue: $searchValue
        boostCriteria: { fieldName: "categoryId", fieldValue: $categoryId }
        filterCriteria: { fieldName: "sysSellerId", fieldValue: $sysSellerId }
      }
    ) {
      id
      catalogNumber
      description
      status
      packageString
      productSource
      categories {
        id
        name
        parents {
          id
          name
        }
      }
      seller {
        id
        name
      }
      sysSeller {
        id
        name
      }
    }
  }
`;

export default GET_CROSSES_BY_SELLER;
